import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AxiosError } from 'axios'

type DeleteDocumentParams = {
  document_key: string
}

export async function deleteDocument({ document_key }: DeleteDocumentParams) {
  const response = await httpClient('accounting-dealer').delete<void>(
    '/v3/file/document',
    {
      params: { document_key },
    },
  )

  return response.data
}

export function useDeleteDocument(
  options?: UseMutationOptions<void, AxiosError, DeleteDocumentParams, unknown>,
) {
  return useMutation({
    mutationFn: deleteDocument,
    ...options,
  })
}
